//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue";
export default {
  name: "choiceScenic",
  components: {
    uniLoadMore
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectList: [],
      spotList: [],
      spotData: [],
      loading: false
    };
  },
  mounted() {
    this.queryData();
  },
  computed: {
    list() {
      return this.spotList.map(t => {
        return {
          name: t.name,
          isMore: t.isMore,
          length: t.children.length,
          children: t.isMore ? t.children : t.children.slice(0, 6)
        };
      });
    },
    isSHowList() {
      let array = [];
      this.spotList.forEach(t => {
        if (t.children) {
          t.children.forEach(tt => {
            if (tt.isShow) {
              array.push(tt);
            }
          });
        }
      });
      return array;
    }
  },
  methods: {
    handleCancel(item) {
      this.cancel(item);
      this.$emit("on-success", this.selectList);
    },
    handleItem(datas) {
      this.selectList = datas;
    },
    handleSuccess() {
      this.$emit("on-success", this.selectList);
    },
    showMore(t, i) {
      this.spotList[i].isMore = !t.isMore;
    },
    queryData() {
      this.loading = true;
      this.$ajax({
        method: "post",
        url: "/weChat/cms/scenicspot/querylistGroupbyRegionCode",
        data: {}
      }).then(res => {
        this.spotList = res.data.map(t => {
          let children = [];
          children = t.value.map(tt => {
            return {
              isShow: false,
              ...tt
            };
          });
          return {
            name: t.name,
            isMore: false,
            children: children
          };
        });
        this.$emit('spotList',this.spotList)
        this.loading = false;
      });
    },
    handle(item) {
      item.isShow = !item.isShow;
      if (this.single) {
        this.spotList.forEach(t => {
          if (t.children) {
            t.children.forEach(tt => {
              if (tt.name !== item.name) {
                tt.isShow = false;
              }
            });
          }
        });
      }
      this.handleItem(this.isSHowList);
    },
    cancel(item) {
      this.spotList.forEach(t => {
        if (t.children) {
          t.children.forEach(tt => {
            if (tt.name === item.name) {
              tt.isShow = false;
            }
          });
        }
      });
      this.handleItem(this.isSHowList);
    }
  }
};
